import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div<{ blockMaxWidth: number }>`
  max-width: ${({ blockMaxWidth }) => blockMaxWidth}px;
  background-color: var(--colorWhite);
  font-size: 14px;
  font-weight: 600;
`;

export const Row = styled.div<{ isHeader?: boolean; isClickable?: boolean; isActive?: boolean }>`
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 8px 32px 8px 28px;
  min-height: 48px;
  letter-spacing: 0.24px;
  color: ${({ isHeader }) => (isHeader ? 'var(--colorWhite)' : 'var(--colorBlueGray1200)')};
  background-color: ${({ isHeader }) =>
    isHeader ? 'var(--colorBlueGray1000)' : 'var(--colorWhite)'};
  border-bottom: ${({ isHeader }) => (isHeader ? 'none' : '1px solid var(--colorBlueGray100)')};
  border-left: 4px solid transparent;
  border-left-color: ${({ isActive }) => (isActive ? 'var(--colorUIYellow)' : 'transparent')};
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ isClickable }) => isClickable && 'var(--colorBlueGray50)'};
  }

  svg {
    opacity: ${({ isActive }) => (isActive ? '1' : '0')};
    position: absolute;
    right: 20px;
    top: 50%;
    fill: var(--colorBlueGray600);
    transform: ${({ isActive }) => (isActive ? 'translate(0, -50%)' : 'translate(-8px, -50%)')};
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  }
`;

export const ItemName = styled.div`
  flex: 1;
`;

export const ItemValue = styled.div`
  color: var(--colorBlueGray800);
  margin-right: auto;
  white-space: nowrap;
`;

export const Button = styled.button<{
  color: string;
  isLoading?: boolean;
  borderColor?: string;
  isDark?: boolean;
  disabled?: boolean;
}>`
  border-radius: 4px;
  border: 1px solid;
  border-color: ${({ borderColor }) => (borderColor ? borderColor : 'var(--colorBlueGray100)')};
  background-color: transparent;
  height: 32px;
  width: 72px;
  color: ${({ color }) => color};
  text-align: center;
  padding: 6px;
  margin-left: 16px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ isLoading }) => (isLoading ? '0.5' : '1')};
  pointer-events: ${({ isLoading, disabled }) => (isLoading || disabled ? 'none' : 'auto')};
  transition: background-color 0.2s ease-in-out;

  &:focus,
  &:hover {
    outline: none;
    background-color: ${({ isDark }) =>
      isDark ? 'var(--colorBlueGray600)' : 'var(--colorBlueGray100)'};
  }
`;
